import type { FaireProductEntity } from "../../entity_types/product";

export const p_bbqtr36dgj: FaireProductEntity = {
  token: "p_bbqtr36dgj",
  type: "product",
  name: "Striped Color Block Thicken Tassel Warm Scarve DPS1315",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/d9f7f9c6ede6854278434989fcd23b668c24e98c7b3f8c4221291b88902f9a21.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e93186fc9c1e48705eb1e682c44d5a3dff2936d18eb7ec5d945c42c8238c00c1.jpeg",
    "https://cdn.faire.com/fastly/94b4768f0c8e7eb45417dcc5eb6c12f21de5283eeef76f5845ac35b3f46ffdad.jpeg",
    "https://cdn.faire.com/fastly/fe0a38f3815ad031069e5b190eafdceb22844b933cbe99ea6b5fedee3d77681a.jpeg",
    "https://cdn.faire.com/fastly/c8b6eca31a90feee06702846e0eefab336fcfc11cea6414910a712aa8158a10f.jpeg",
    "https://cdn.faire.com/fastly/f3b290bfd1fe750685ee8df849169a38b7b5c93817d1e76bda8bae4afce57d5d.jpeg",
    "https://cdn.faire.com/fastly/af9768b3e4d5aa34b52512975bdc4b936da02d659b53fc3e4d6e11bedb8b90af.jpeg",
    "https://cdn.faire.com/fastly/ae50210e6fe1d90aa2c5d1a31781ea939a8ba297cc7b4cd3208fa8766c18f878.jpeg",
    "https://cdn.faire.com/fastly/3ee790f113a5e6e34bd81dc1fb1b757485c74b1db68f10cfce265a3bd06e0f39.jpeg",
    "https://cdn.faire.com/fastly/86c37a3212a9d7e066aaa5ef81098cc293f0b66d0b158889224964f904388c5b.jpeg",
    "https://cdn.faire.com/fastly/f33ab61d634219559f2ca8d4c42198dbe5eb43e8b43a67dbc900140ae16f5a8e.jpeg",
  ],
  priceDollars: 12.49,
  description:
    "Feature:\n * Striped \n * Color Block\n * Tassel Design\n * Soft\n * Long\n * Warm\n * Winter Wear\n\n Weigh:\n * 280g\n\n Size:\n * Scarves: 210 * 40cm\n\n Material:\n * Polyester \n\n Package:\n * Package include 1 scarve.\n\n Note:\n * See picture labels (size and weight are hand-measured there will be a small error, specific in kind shall prevail, please note the size before purchase)\n * Care instructions: hand wash in cold water, hang dry, can be ironed at low temperature.",
  tags: [],
  msrpDollars: 24.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:38.295Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
